export const casesData = [
  {
    id: 1,
    title: "Bazabag",
    subtitle: "Интернет-магазин сумок",
    image: "/assets/images/bazabag-1.webp",
    link: "https://bazabag.ru"
  },
  {
    id: 11,
    title: "POVOD",
    subtitle: "Приложение для знакомств",
    image: "/assets/images/povod.webp",
    link: "https://t.me/povodme_bot"
  },
  {
    id: 2,
    title: "Scentscape",
    subtitle: "Интернет-магазин парфюмерии",
    image: "/assets/images/scentscape-1.webp",
    link: "https://scentscape.me"
  },
  {
    id: 4,
    title: "Mi Alegria",
    subtitle: "Интернет-магазин украшений",
    image: "/assets/images/mialegria-1.webp",
    link: "https://mi-alegria.shop"
  },
  {
    id: 5,
    title: "Вега",
    subtitle: "Лендинг международной школы по финансовой математике",
    image: "/assets/images/vega-1.webp",
    link: "https://vega-school.org/2025-august"
  },
  {
    id: 6,
    title: "NEOFAMILY",
    subtitle: "Мини-приложение Telegram — игра для учеников",
    image: "/assets/images/neofamily-1.png",
    link: "https://t.me/ege_battle_bot"
  },
  {
    id: 9,
    title: "Lagom",
    subtitle: "Личный кабинет VPN-сервиса",
    image: "/assets/images/lagom-lk.webp",
    link: "http://lk-lag.one/"
  },
  {
    id: 3,
    title: "Friends",
    subtitle: "Сервис партнёрского маркетинга",
    image: "/assets/images/friends-1.webp",
    link: "https://friends.promo"
  },
  {
    id: 10,
    title: "MathProff",
    subtitle: "Онлайн-платформа для подготовки к ЕГЭ и ОГЭ",
    image: "/assets/images/mathproff.webp",
    link: "https://mathproff.ru"
  },
  {
    id: 7,
    title: "SIE Moscow",
    subtitle: "Мини-приложение Telegram — сервис для создания свиданий",
    image: "/assets/images/sie-1.webp",
    link: "https://t.me/siemoscow_bot"
  },
  {
    id: 8,
    title: "Студия йоги Мёд",
    subtitle: "Лендинг для студии йоги и массажа",
    image: "/assets/images/medstudio-1.png",
    link: "https://med-yoga-studio.ru/"
  },
  {
    id: 13,
    title: "Сервис пропуск",
    subtitle: "Оформление пропусков для авто",
    image: "/assets/images/spropusk.webp",
    link: "https://spropusk.ru/"
  },
];
